import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '../apiservices/apiUrl.provider';
import { lastValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class urlService {

  private readonly _API_URL = inject(API_URL);
  private readonly $http = inject(HttpClient);

  /**
   * Given a URL, executes the download of the file.
   */
  public download(url: string, name = "file", replaceProtocol = true): void {
    var link = document.createElement("a");
    link.download = name;
    link.href = replaceProtocol ? this._replaceUrlProtocol(url) : url;
    link.click();
  }

  /**
   * Replaces the HTTP protocol of a given URL for the protocol used by the API URL.
   */
  private _replaceUrlProtocol(url: string): string {
    var apiProtocol = new URL(this._API_URL).protocol;
    var newUrl = new URL(url);
    newUrl.protocol = apiProtocol;
    return newUrl.href;
  }

  public downloadBlob(fileUrl: string, replaceProtocol = true): Promise<void> {
    const url = replaceProtocol ? this._replaceUrlProtocol(fileUrl) : fileUrl;
    const fileName = url.split('/').pop()?.split('?')[0] || "file";
    return lastValueFrom(
      this.$http.get(url, { responseType: 'arraybuffer' })
        .pipe(
          map(buffer => new Blob([buffer]))
        )
    )
      .then(this._createBlobLink(fileName));
  }

  private _createBlobLink(fileName: string) {
    return (blob: Blob): void => {
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(objectUrl);
    }
  }

  /**
   * Allows to download any javascript type as a JSON file.
   * @param data any javascript type.
   * @param name optional, name for the file, do not include extension (.json).
   */
  public downloadAsJson(data: unknown, name = "file"): void {
    const link = document.createElement("a");
    link.download = `${name}.json`;
    link.href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`;
    link.click();
  }
}
